import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { WorkspaceDashboard } from '@copilot/ui';
import Loader from '../components/common/Loader';
import UpcomingAutoAttendCard from '../components/autoAttend/UpcomingAutoAttendCard';
import DashboardEntitlement from '../components/pricing/DashboardEntitlement';
import { LANGUAGES } from '../constants/languages';
import { useAuth } from '../hooks/useAuth';
import * as meetingApi from '../services/meetingApi';
import { getUserFriendlyError } from '../utils/errors';

// The signed-in home screen - @copilot/ui's WorkspaceDashboard, shared
// with Desktop, wired to Web's API calls and routes.
function DashboardPage() {
  const { user } = useAuth();
  const navigate = useNavigate();

  const api = useMemo(
    () => ({
      getSummaryStats: () => meetingApi.getSummaryStats(),
      listRecentMeetings: async () => (await meetingApi.listMeetings({ page: 1, pageSize: 5 })).items,
      describeError: (error, fallback) => getUserFriendlyError(error, fallback),
    }),
    []
  );

  return (
    <WorkspaceDashboard
      api={api}
      userName={user?.full_name}
      languages={LANGUAGES}
      loadingIndicator={<Loader label="Loading dashboard..." />}
      onNewMeeting={() => navigate('/app/meeting/new')}
      onOpenMeetings={() => navigate('/app/history')}
      onOpenAnalytics={() => navigate('/app/analytics')}
      onOpenAsk={() => navigate('/app/memory')}
      onOpenMeeting={(meetingId) => navigate(`/app/meeting/${meetingId}`)}
      // The plan card first: what plan, how many meetings are left and
      // what to do next, without opening Plan & Billing. Then Auto
      // Attend, which renders nothing unless there is something
      // upcoming, so the dashboard never depends on it being available.
      beforeOverview={
        <>
          <DashboardEntitlement />
          <UpcomingAutoAttendCard />
        </>
      }
    />
  );
}

export default DashboardPage;
